/**
 * Plugin for initializing Clustersie theme
 */
export default defineNuxtPlugin(() => {
  // Only run on client side
  if (process.server) return

  const { getCurrentSubdomain, getSubdomainFromQuery } = useClustersie()
  
  // Initialize theme detection
  const initClustersieTheme = () => {
    const querySubdomain = getSubdomainFromQuery()
    const actualSubdomain = getCurrentSubdomain()
    
    // For development, prefer query parameter
    const subdomain = querySubdomain || actualSubdomain
    
    // Set theme data in app context (only if not already set)
    const nuxtApp = useNuxtApp()
    if (!nuxtApp.$clustersieSubdomain) {
      nuxtApp.provide('clustersieSubdomain', subdomain)
    }
    
    // Add subdomain class to body for conditional styling
    if (process.client && document.body) {
      document.body.classList.add(`subdomain-${subdomain}`)
      
      // Remove other subdomain classes
      const validSubdomains = ['main', 'coffee', 'fisheries', 'fruit', 'bittermelon', 'halal', 'mulberry']
      validSubdomains.forEach(sub => {
        if (sub !== subdomain) {
          document.body.classList.remove(`subdomain-${sub}`)
        }
      })
    }
    
    console.log('Clustersie Theme initialized for subdomain:', subdomain)
  }
  
  // Initialize on app start
  initClustersieTheme()
  
  // Re-initialize on navigation
  const router = useRouter()
  router.afterEach(() => {
    nextTick(() => {
      initClustersieTheme()
    })
  })
})